"use client";

import dynamic from "next/dynamic";
import { Visit360Modal } from "@/features/visit360/components/Visit360Modal";

/**
 * The media viewer brings `react-image-gallery` with it and is never on screen at
 * first paint, so it stays out of the initial bundle.
 */
const GalleryModal = dynamic(
  () =>
    import("@/features/gallery/components/GalleryModal").then(
      (module) => module.GalleryModal
    ),
  { ssr: false }
);

/**
 * The viewers a POI's gallery cards open.
 *
 * They belong wherever POI details are shown — the app shell and the standalone
 * POI page — because a gallery card only writes the chosen media to a store. With
 * no viewer mounted to read it, the card is a button that does nothing, which is
 * what the POI page had until these moved out of the layout.
 *
 * Rendered as a pair because the card decides between them: a 360° tour takes the
 * whole viewport instead of a slide in the carousel.
 */
export function MediaModals() {
  return (
    <>
      <GalleryModal />
      <Visit360Modal />
    </>
  );
}
